import { Field } from "react-final-form"

import { ALink, CheckboxControl } from "@trueskin-web/components"
import { Slugs } from "@trueskin-web/translations"

const TermsCheckbox = () => (
  <Field
    dataTestId="web-portal-agree-terms"
    name="agreeTerms"
    component={CheckboxControl}
    validate={(value) =>
      value ? undefined : "Bitte bestätige die Box, um fortzufahren"
    }
    mobileErrorMessagePosition="top"
    type="checkbox"
    sx={{
      mt: 5,
      fontSize: 0,
      lineHeight: "smallerHeading",
    }}
  >
    Ich bin einverstanden mit den{" "}
    <ALink
      href={Slugs["terms-and-conditions"].url}
      target="_blank"
      isUnderlined
      sx={{
        fontWeight: "bold",
      }}
    >
      AGB
    </ALink>
    , der{" "}
    <ALink
      href={Slugs["terms-and-conditions"].url}
      target="_blank"
      isUnderlined
      sx={{
        fontWeight: "bold",
      }}
    >
      Widerrufsbelehrung
    </ALink>{" "}
    und dem{" "}
    <ALink
      href={Slugs["data-protection"].url}
      target="_blank"
      isUnderlined
      sx={{
        fontWeight: "bold",
      }}
    >
      Datenschutzhunweis
    </ALink>
    . Ich willige ein in die Verarbeitung personenbezogener Daten
    (einschließlich Gesundheitsdaten) durch die FORMEL SKIN Gruppe und die
    ausgewählte Apotheke für die Zwecke der Leistungserbringung, und die
    Abrechnung über die FORMEL SKIN Derma GmbH, der mein Arzt meine
    Rechnungsdaten (ohne Befunde) übermitteln darf.
  </Field>
)

export default TermsCheckbox
